import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import routes from './router/routes'
import store from './store'
// import VueLazyload from 'vue-lazyload'

Vue.config.productionTip = false

// Vue.use(VueLazyload, {
//   preLoad: 1.3,
//   attempt: 1,
//   lazyComponent: true
// })


Vue.use(VueRouter)
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes
})

//lazyloadingイベント用のカスタムディレクティブ
Vue.directive('onlazy', {
  inserted: function (el, binding) {
    let f = function (evt) {

      let rect = el.getBoundingClientRect()
      let elemPos = window.pageYOffset + rect.top - window.outerHeight
      // console.log(window.scrollY,elemPos)

      if (window.scrollY > elemPos) {
        binding.value(evt, el)
        window.removeEventListener('scroll', f)
      }
    }
    window.addEventListener('scroll', f)
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
